var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfCircleBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.543 84.5779C160.543 63.3606 152.114 43.0122 137.112 28.0093C122.109 13.0064 101.76 4.57789 80.543 4.57789C59.3256 4.57789 38.9773 13.0064 23.9744 28.0094C8.97151 43.0123 0.542967 63.3606 0.542969 84.5779C0.542967 62.2997 8.97151 40.934 23.9744 25.1809C38.9773 9.42787 59.3256 0.57789 80.543 0.577888C101.76 0.577886 122.109 9.42786 137.112 25.1809C152.114 40.934 160.543 62.2997 160.543 84.5779Z",
    fill: "#564ECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircleBlue);
export default __webpack_public_path__ + "static/media/HalfCircleBlue.f4e63ceac674c4ab6aa4c42d486c7933.svg";
export { ForwardRef as ReactComponent };